/**
 * @generated SignedSource<<51974dd67839b19f41ab9b7bfadb0a60>>
 * 
 * @lightSyntaxTransform
 *//* eslint-disable */'use strict';/*::
import type { Fragment, ReaderFragment } from 'relay-runtime';
export type AppAssetSelection = "CANDIDATE" | "CHOSEN";
import type { FragmentType } from "relay-runtime";
declare export opaque type AppAssetSection_asset$fragmentType: FragmentType;
export type AppAssetSection_asset$data = {|
  +candidates: ReadonlyArray<{|
    +assetKey: string,
    +contentType: string,
    +createdAt: string,
    +height: number,
    +id: string,
    +objectKey: string,
    +selection: AppAssetSelection,
    +url: string,
    +width: number,
  |}>,
  +declared: boolean,
  +key: string,
  +purpose: string,
  +$fragmentType: AppAssetSection_asset$fragmentType,
|};
export type AppAssetSection_asset$key = {
  +$data?: AppAssetSection_asset$data,
  +$fragmentSpreads: AppAssetSection_asset$fragmentType,
  ...
};
*/var node/*: ReaderFragment*/={"argumentDefinitions":[],"kind":"Fragment","metadata":null,"name":"AppAssetSection_asset","selections":[{"alias":null,"args":null,"kind":"ScalarField","name":"key","storageKey":null},{"alias":null,"args":null,"kind":"ScalarField","name":"purpose","storageKey":null},{"alias":null,"args":null,"kind":"ScalarField","name":"declared","storageKey":null},{"alias":null,"args":null,"concreteType":"GraphQLAppAssetCandidate","kind":"LinkedField","name":"candidates","plural":true,"selections":[{"alias":null,"args":null,"kind":"ScalarField","name":"id","storageKey":null},{"alias":null,"args":null,"kind":"ScalarField","name":"assetKey","storageKey":null},{"alias":null,"args":null,"kind":"ScalarField","name":"url","storageKey":null},{"alias":null,"args":null,"kind":"ScalarField","name":"objectKey","storageKey":null},{"alias":null,"args":null,"kind":"ScalarField","name":"contentType","storageKey":null},{"alias":null,"args":null,"kind":"ScalarField","name":"width","storageKey":null},{"alias":null,"args":null,"kind":"ScalarField","name":"height","storageKey":null},{"alias":null,"args":null,"kind":"ScalarField","name":"selection","storageKey":null},{"alias":null,"args":null,"kind":"ScalarField","name":"createdAt","storageKey":null}],"storageKey":null}],"type":"GraphQLInternalAppAsset","abstractKey":null};node/*:: as any*/.hash="72bb49cb46462209e82500472f913e40";export default node/*:: as any*//*:: as Fragment<
  AppAssetSection_asset$fragmentType,
  AppAssetSection_asset$data,
>*/;